const comments = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20cute%20cartoon%20avatar%20of%20a%20young%20male%20character%20with%20black%20hair%2C%20simple%20warm%20tones%2C%20minimalist%20design%2C%20flat%20illustration%20style%2C%20friendly%20expression&width=96&height=96&seq=avatar-01&orientation=squarish',
    text: '用51漫画在线看漫画真的太爽了！下拉式阅读完全不用等加载，画质也非常清晰。以前要下载好几个APP，现在一个网址就搞定，强烈推荐给所有漫画爱好者。',
    date: '3天前',
    tag: '忠实读者',
  },
  {
    name: '追更少女阿琳',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20cute%20cartoon%20avatar%20of%20a%20young%20female%20character%20with%20long%20hair%2C%20simple%20warm%20tones%2C%20minimalist%20design%2C%20flat%20illustration%20style%2C%20happy%20smile&width=96&height=96&seq=avatar-02&orientation=squarish',
    text: '斗破苍穹和狐妖小红娘每天都在51漫画免费看，更新速度是我用过最快的平台。编辑推荐的质量也很高，已经在这里发现了好几部宝藏漫画了。',
    date: '5天前',
    tag: 'VIP读者',
  },
  {
    name: '老读者大刘',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylized%20cute%20cartoon%20avatar%20of%20a%20mature%20male%20character%20with%20glasses%2C%20simple%20warm%20tones%2C%20minimalist%20design%2C%20flat%20illustration%20style%2C%20calm%20expression&width=96&height=96&seq=avatar-03&orientation=squarish',
    text: '看了十几年漫画，51漫画网的阅读体验是最好的。高清全彩、下拉式翻页、分类清晰，51漫画在线阅读看全集免费还不用下载，这才是读者真正需要的平台。',
    date: '1周前',
    tag: '资深漫迷',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">读者评价</h2>
          <p className="text-sm text-foreground-600">来自51漫画网真实读者的阅读感受</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((c, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.date}</p>
                </div>
                <span className="ml-auto px-2 py-0.5 bg-primary-100 text-primary-700 rounded-md text-xs font-medium">{c.tag}</span>
              </div>
              <div className="mb-3 flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}